import data from './assets/data.json'

export function getSelectedList () {
  let yearArray = ['Freshman', 'Sophomore', 'Junior', 'Senior']
  let sortedData = data.data.filter(x => {
    let i = 0
    x.proposals.map(proposal => {
      if (proposal.selected === '1') {
        i++
      }
      return null
    })
    if (i > 0) {
      return true
    }
    return false
  })

  return sortedData.sort(function (a, b) {
    let textA = a['Name of the applicant'].toUpperCase()
    let textB = b['Name of the applicant'].toUpperCase()
    if (yearArray.indexOf(a.Year) - yearArray.indexOf(b.Year) === 0) {
      return textA < textB ? -1 : textA > textB ? 1 : 0
    }
    return yearArray.indexOf(a.Year) - yearArray.indexOf(b.Year)
  })
}

export function getDetails (username) {
  let detail = getSelectedList()[username - 1]
  detail = {
    ...detail,
    proposals: detail.proposals.sort(x => x.selected).reverse()
  }
  return detail
}

export function checkUsername (username) {
  let detail = getSelectedList()[username - 1]
  return Boolean(detail)
}
